import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <h1>About California Tax Calculator</h1>
      <div className="about-content">
        <section className="about-section">
          <h2>Our Purpose</h2>
          <p>
            The California Tax Calculator provides a simple, accurate way for California residents 
            and businesses to estimate their tax obligations. Our goal is to make complex tax 
            calculations accessible and understandable for everyone, helping you plan your finances 
            with confidence.
          </p>
        </section>
        
        <section className="about-section tax-types-section">
          <h2>California Tax Types</h2>
          
          <div className="tax-type-card">
            <h3>Sales and Use Tax</h3>
            <p>
              California's sales tax has multiple components: a state base rate of 7.25% plus district 
              taxes that vary by location. Our calculator uses up-to-date rates for all California 
              counties, accounting for local variations to give you precise estimates.
            </p>
            <div className="tax-type-details">
              <span className="detail-label">Base Rate:</span>
              <span className="detail-value">7.25%</span>
            </div>
            <div className="tax-type-details">
              <span className="detail-label">Range:</span>
              <span className="detail-value">7.25% - 10.75%</span>
            </div>
          </div>
          
          <div className="tax-type-card">
            <h3>Personal Income Tax</h3>
            <p>
              California uses a progressive income tax system with nine tax brackets. The tax rate 
              ranges from 1% to 12.3%, with an additional 1% surcharge on income over $1 million 
              (Mental Health Services Tax). Our calculator applies these rates to your income based 
              on your filing status.
            </p>
            <div className="tax-type-details">
              <span className="detail-label">Brackets:</span>
              <span className="detail-value">9</span>
            </div>
            <div className="tax-type-details">
              <span className="detail-label">Range:</span>
              <span className="detail-value">1% - 13.3%</span>
            </div>
          </div>
          
          <div className="tax-type-card">
            <h3>Property Tax</h3>
            <p>
              California property tax is governed by Proposition 13, which limits the tax to 1% of 
              the assessed value plus voter-approved local assessments. Our calculator estimates these 
              taxes based on your property's value and location.
            </p>
            <div className="tax-type-details">
              <span className="detail-label">Base Rate:</span>
              <span className="detail-value">1%</span>
            </div>
            <div className="tax-type-details">
              <span className="detail-label">Average Effective Rate:</span>
              <span className="detail-value">0.73%</span>
            </div>
          </div>
        </section>
        
        <section className="about-section">
          <h2>How It Works</h2>
          <p>
            Our calculator uses the latest California tax rates and regulations to provide accurate 
            estimates. For sales tax, we maintain a database of county-specific rates that are 
            updated regularly. For income tax, we apply the progressive tax brackets based on your 
            income and filing status. Our property tax calculator applies the base rate plus estimated 
            local assessments based on county.
          </p>
          <p>
            Simply input your information in the relevant calculator, and we'll do the math for you.
          </p>
        </section>
        
        <section className="about-section">
          <h2>Data Sources</h2>
          <p>
            Our tax information is sourced from official California government resources:
          </p>
          <ul className="data-sources">
            <li>California Department of Tax and Fee Administration (CDTFA)</li>
            <li>Franchise Tax Board (FTB)</li>
            <li>California State Board of Equalization</li>
            <li>County assessors' offices</li>
          </ul>
          <p>
            We update our rates and calculations whenever changes are made to California tax laws.
          </p>
        </section>
        
        <section className="about-section">
          <h2>Disclaimer</h2>
          <p>
            The calculations provided by this tool are estimates only and are not guaranteed to be 
            accurate. Tax laws are complex and subject to change. While we strive to provide 
            up-to-date information, this calculator should not be relied upon as a substitute for 
            professional tax advice. For official tax guidance, please consult with a certified 
            tax professional.
          </p>
        </section>
      </div>
    </div>
  );
}

export default About;
